import { GroupOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'
import { TenantPermission } from '@tabeeb/enums'
import { getIsSwitchTenantFeatureEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { NavbarItem } from '@collaborate-health/uikit'

const TenantsTab: React.FC = () => {
  const display = useSelector(
    (state) => hasTenantPermission(state, TenantPermission.AllTenantsAccess) && getIsSwitchTenantFeatureEnabled(state)
  )
  if (!display) {
    return null
  }

  return <NavbarItem name='Tenants' href={Routes.tenants} icon={<GroupOutlined />} />
}

export default TenantsTab

